import { withProps } from 'components/core/utils'
import { Text } from 'components'
import { badgeRoles, PersonListItem } from 'libs/api'
import { IntlShape } from 'react-intl'
import translations from '../People.i18n.json'
import { Column } from 'modules/Common/ListPage'
import { getName } from './getName'
import React from 'react'
// import { HealthScreeningChip } from 'components/HealthScreeningChip'
import { PersonAvatar } from '../components/PersonAvatar'
import { BadgeEnabledChip } from '../components/BadgeEnabledChip/BadgeEnabledChip'

const RowText = withProps(Text, { fontSize: 'sm', shade: 1 })

type ExtraColumns = {
  company_name?: boolean
}

export const buildColumns = (
  intl: IntlShape,
  healthMode: boolean,
  extraColumns: ExtraColumns = {}
): Column<PersonListItem>[] => [
  {
    width: 10,
    title: '',
    render: (person) => <PersonAvatar person={person} borderRadius={2} />,
  },
  {
    sortKey: 'name',
    title: intl.formatMessage(translations.name),
    render: (person) => <RowText>{getName(person)}</RowText>,
  },
  ...(extraColumns.company_name
    ? [
        {
          title: intl.formatMessage(translations.companyName),
          render: (person: PersonListItem) => <RowText>{person.company_name ?? ''}</RowText>,
        },
      ]
    : []),
  {
    title: intl.formatMessage(translations.badge),
    render: (item) => <BadgeEnabledChip person={item} />,
    textAlign: 'center',
  },
  {
    title: intl.formatMessage(translations.badgeRole),
    render: (person) => <RowText>{person.badge?.custom_fields?.badge_role ?? badgeRoles[0].name}</RowText>,
    textAlign: 'center',
  },
  {
    sortKey: 'zones',
    title: intl.formatMessage(translations.locations),
    render: (person) => <RowText>{person.zones.map((zone) => zone.name).join(', ')}</RowText>,
  },
  {
    sortKey: 'access_groups',
    title: intl.formatMessage(translations.accessGroups),
    render: (person) => <RowText>{person?.access_groups?.map((it) => it.name).join(', ') ?? ''}</RowText>,
  },
]
